import { render, staticRenderFns } from "./Localizator.vue?vue&type=template&id=43e02216&"
import script from "./Localizator.vue?vue&type=script&lang=js&"
export * from "./Localizator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports